import { useEffect, useState } from "react";
import { entCreateScheduled, entListScheduled } from "../salaryEnterpriseApi";
import { useToast } from "../../../Context/ToastContext";
import DatePickerField from "../../../../components/common/DatePickerField";
import EmployeeSelect from "../../../../components/common/EmployeeSelect";

export default function SalaryScheduledEarnings() {
  const toast = useToast();
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({
    employee_id: "",
    earning_type: "joining_bonus",
    amount: "",
    frequency: "one_time",
    payout_date: "",
    comments: "",
  });

  async function load() {
    const data = await entListScheduled();
    setRows(Array.isArray(data) ? data : []);
  }

  useEffect(() => {
    load().catch(() => setRows([]));
  }, []);

  async function onCreate(e) {
    e.preventDefault();
    try {
      await entCreateScheduled({
        ...form,
        amount: Number(form.amount),
        payout_date: form.payout_date || null,
      });
      toast.success("Scheduled earning created");
      setForm({ employee_id: "", earning_type: "joining_bonus", amount: "", frequency: "one_time", payout_date: "", comments: "" });
      await load();
    } catch (err) {
      toast.error(err?.detail || "Failed");
    }
  }

  return (
    <div className="bw-stack">
      <h2 className="bw-section-title">Scheduled earnings</h2>
      <form className="bw-form-grid" onSubmit={onCreate}>
        <div className="bw-field xl-4">
          <EmployeeSelect
            label="Employee"
            required
            value={form.employee_id}
            onChange={(id) => setForm((p) => ({ ...p, employee_id: id }))}
            selectClassName="bw-input w-full"
          />
        </div>
        <div className="bw-field xl-4">
          <label className="bw-label">Type</label>
          <select className="bw-select" value={form.earning_type} onChange={(e) => setForm((p) => ({ ...p, earning_type: e.target.value }))}>
            <option value="joining_bonus">Joining bonus</option>
            <option value="retention_bonus">Retention bonus</option>
            <option value="annual_bonus">Annual bonus</option>
            <option value="festival_bonus">Festival bonus</option>
            <option value="sales_incentive">Sales incentive</option>
            <option value="custom">Custom</option>
          </select>
        </div>
        <div className="bw-field xl-4">
          <label className="bw-label">Amount</label>
          <input className="bw-input" type="number" required value={form.amount} onChange={(e) => setForm((p) => ({ ...p, amount: e.target.value }))} />
        </div>
        <div className="bw-field xl-4">
          <label className="bw-label">Frequency</label>
          <select className="bw-select" value={form.frequency} onChange={(e) => setForm((p) => ({ ...p, frequency: e.target.value }))}>
            <option value="one_time">One time</option>
            <option value="monthly">Monthly</option>
            <option value="quarterly">Quarterly</option>
            <option value="half_yearly">Half yearly</option>
            <option value="yearly">Yearly</option>
          </select>
        </div>
        <div className="bw-field xl-4">
          <label className="bw-label">Payout date</label>
          <DatePickerField hideLabel value={form.payout_date} onChange={(date) => setForm((p) => ({ ...p, payout_date: date }))} inputClassName="bw-input" placeholder="Payout date" />
        </div>
        <div className="bw-field xl-8">
          <label className="bw-label">Comments</label>
          <input className="bw-input" value={form.comments} onChange={(e) => setForm((p) => ({ ...p, comments: e.target.value }))} />
        </div>
        <div className="bw-field xl-12">
          <button type="submit" className="bw-btn bw-btn-primary">
            Add scheduled earning
          </button>
        </div>
      </form>

      <div className="bw-table-wrap">
        <table className="bw-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Frequency</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td className="text-xs">{r.employee_id}</td>
                <td>{r.earning_type}</td>
                <td>{r.amount}</td>
                <td>{r.frequency}</td>
                <td>{r.status}</td>
              </tr>
            ))}
            {rows.length === 0 ? (
              <tr>
                <td colSpan={5} className="bw-table-empty">
                  No scheduled earnings yet.
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
}
